import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatListItem, MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatToolbarModule } from '@angular/material/toolbar';
import { RouterModule } from '@angular/router';
import { RECAPTCHA_V3_SITE_KEY, RecaptchaV3Module } from 'ng-recaptcha';

@Component({
  selector: 'app-welcome',
  standalone: true,
  imports: [
    MatToolbarModule,
    MatIconModule,
    MatButtonModule,
    MatListModule,
    MatMenuModule,
    RouterModule,
    RecaptchaV3Module,
  ],
  template: `
    <mat-toolbar>
      <div class="mat-toolbar-content">
        <div class="column-full-space" [routerLink]="['/welcome/index']">
          <img src="./assets/images/logo.png" class="logo">
        </div>
        <!-- <button mat-button>PAQUETES DE SERVICIOS</button> -->
        <button mat-button class="show-desktop" [routerLink]="['/welcome/contact-pqr']">REPORTAR PQR</button>
        <button mat-button class="show-desktop" [routerLink]="['/welcome/contact']">CONTACTAR</button>
        <button mat-button class="show-desktop" color="primary" [routerLink]="['/signin']">ENTRAR</button>
        <button mat-button matIconButton [matMenuTriggerFor]="menu" aria-label="Example icon-button with a menu" class="show-mobile">
          <mat-icon>menu</mat-icon>
        </button>
        <mat-menu #menu="matMenu">
          <button [routerLink]="['/welcome/contact-pqr']" mat-menu-item routerLinkActive="active-link">
            <span>REPORTAR PQR</span>
          </button>
          <button mat-menu-item [routerLink]="['/welcome/contact']">
            <span>CONTACTAR</span>
          </button>
          <button mat-menu-item [routerLink]="['/signin']">
            <span>ENTRAR</span>
          </button>
        </mat-menu>
      </div>
    </mat-toolbar>
    <div id='stars'></div>
    <div id='stars2'></div>
    <div id='stars3'></div>
    <router-outlet></router-outlet>
  `,
  styleUrls: ['./welcome.component.css']
})
export class WelcomeComponent {
  snav
}
